// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"0c2974cb","365":"57af0c63","948":"95288c0a"}[chunkId] + ".chunk.css";
};